import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

let csrf = null;
export const setCsrf = (t) => { csrf = t; };
export const getCsrf = () => csrf;

// Operator API — opaque httpOnly session cookie + CSRF header on mutations
export const opApi = axios.create({ baseURL: API, withCredentials: true });
opApi.interceptors.request.use((config) => {
  const m = (config.method || "get").toLowerCase();
  if (csrf && !["get", "head", "options"].includes(m)) {
    config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

// Customer API — JWT bearer from localStorage
export const custApi = axios.create({ baseURL: API });
custApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("mc_customer_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Public / embed API
export const publicApi = axios.create({ baseURL: API });

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
